import { render, staticRenderFns } from "./EventoDetalhe.vue?vue&type=template&id=226ed8fd&scoped=true&lang=pug&"
import script from "./EventoDetalhe.vue?vue&type=script&lang=js&"
export * from "./EventoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./EventoDetalhe.vue?vue&type=style&index=0&id=226ed8fd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ed8fd",
  null
  
)

export default component.exports